module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body test col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maker),
      expression: "maker"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.maker = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Maker")]), _vm._v(" "), _vm._l((_vm.Makers), function(maker) {
    return _c('option', {
      key: maker._id,
      domProps: {
        "value": maker._id
      }
    }, [_vm._v("\n                  " + _vm._s(maker.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Name),
      expression: "Name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Enter Name"
    },
    domProps: {
      "value": (_vm.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/*",
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer test"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.addModelSeries()
      }
    }
  }, [_vm._v("\n              Save\n            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable wrap",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.Series), function(S, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.name))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.company.name))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-outline-delete",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.deleteModelSeries(S)
        }
      }
    }, [_vm._v("\n                        Delete\n                      ")])])])
  }))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Add Model Series")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Maker "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Name "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("File "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Company Name")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20438c26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AddModelSeries.vue
// module id = 1469
// module chunks = 1